"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurableListColumns = exports.configurableListEntityName = void 0;
const storage_1 = require("@juvare/platform-shared/features/storage");
exports.configurableListEntityName = 'configurableList';
exports.configurableListColumns = (0, storage_1.defineColumns)({
    name: {
        type: 'string-required',
        caseSensitive: true,
        index: 'unique',
    },
    value: {
        type: 'string-required',
    },
    description: {
        type: 'string-required',
        index: true,
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});
